import {useCookies} from "react-cookie";
import { useNavigate } from "react-router-dom";
import user_icon from '../img/icon/user-icon.svg';

import exit from "../exit.svg";

const ChatHeader = ({user}) => {

    const [cookies, , removeCookie] = useCookies(['user'])
    let navigate = useNavigate()
    const logout = () => {
        removeCookie('UserId',cookies.UserId)
        removeCookie('AuthToken',cookies.AuthToken)
        navigate('/')

    }

    return(
        <div className="chat-container-header">
            <div className="profile">
                <div className="profile-img-container">
                    <img onClick={() => navigate("/onboarding/change")} src={user.pic ? user.pic: user_icon} alt ={"photo of " +user.user_id}/>
                </div>
            </div>
            <div className="log-out-img-container" onClick={(logout)}> 
                <img src={exit} alt ={"log out icon"}/>
            </div>
        </div>
    )
}
export default ChatHeader